<img class="svg {{type()}}" [style.width]="size()+'rem'" [style.height]="size()+'rem'" [src]="basePath + svg() + suffix() + '.svg'" [alt]="svg()"/>
